<template>
    <div class="row" v-if="productInfo.SimilarProducts != null && productInfo.SimilarProducts.length > 0 ">
        <div class="col-12 ">
            <div class="widget widget-product card">
                <div class="owl-stage-outer">
                    <h6>محصولات مشابه</h6>
                    <div class="product-carousel owl-carousel owl-item">
                        <div style="position:relative" class="item discount-box" v-for="similarProduct in  productInfo.SimilarProducts">
                            <a :href="'/product/'+ similarProduct.Id + '/' + similarProduct.Name.replace(/\s+/g, '-')" class="pointer">
                                <img :src="similarProduct.PicPath" class="img-fluid" :alt="similarProduct.Name" :title="similarProduct.Name" @error="imageLoadOnError" />
                            </a>
                            <div class="div-post-title">
                                <h2 class="post-title">
                                    <a :title="similarProduct.Name" :href="'/product/'+ similarProduct.Id + '/' + similarProduct.Name.replace(/\s+/g, '-')">{{ similarProduct.Name }}</a>
                                </h2>
                            </div>

                            <div class="price">
                                <div class="text-center main-price-all">

                                    <div v-if="!similarProduct.IsAvailable">
                                        <span class="unAvailable">ناموجود</span>
                                    </div>
                                </div>
                            </div>

                            <div class="wi-div-in" v-if="similarProduct.IsAvailable">
                                <i @click="AddItemWithProductId(similarProduct.Id)" class="incress-wi now-ui-icons ui-1_simple-add "></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { setCart } from "../../module/cart";
    export default {
        props: {
            productInfo: {
                type: Object,
            },
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            AddItemWithProductId(productId) {
                setCart(this, productId, 'AddItemWithProductId', '.loader', null, 1);
            }
        }
    }
</script>

<style scoped>
    .item {
        position: relative;
        overflow: hidden;
    }

    .unavailable-product-similler {
        -moz-transform: rotate(-10deg);
        -webkit-transform: rotate(-10deg);
        -o-transform: rotate(-10deg);
        -ms-transform: rotate(-10deg);
        transform: rotate(-10deg);
        border: 4px double #fff;
        padding: 0px 10px 5px 10px;
        display: inline-block;
        background-color: #ff919998;
        color: #fff;
        font-size: 15px;
        overflow: hidden;
        z-index: 10;
        position: absolute;
        top: -60px;
        left: 5px;
        transition: all .3s;
    }

    .item:hover .unavailable-product-similler {
        transition: all .3s;
        top: 20px !important;
    }



    .widget-product .product-carousel .item in {
        font-size: 17px;
    }

    .main-div-dd {
        display: inline-block;
    }

    .main-price-all {
        position: relative;
    }

    .main-discount-all {
        position: absolute;
        z-index: 1;
        top: -18px;
    }

    .product-carousel .owl-item img {
        max-width: 48%;
    }

    .widget-product .product-carousel .item .price del, .brand-slider .product-carousel .item .price del {
        color: #979898;
        font-size: 16px;
    }

    .widget-product .product-carousel .item .div-post-title {
        padding: 7px;
    }

    .widget-product .product-carousel .item .post-title {
        margin-bottom: 0;
        max-height: unset;
        height: unset;
    }

    .item {
        position: relative;
    }

        .item .discount {
            content: '';
            width: 55px;
            height: 35px;
            background-color: #ef5662;
            color: #fff;
            top: 20px;
            left: 15px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            border-radius: 40px;
            z-index: 9999;
            font-size: 16px;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .widget-product .product-carousel .item ins, .brand-slider .product-carousel .item ins {
            font-size: 18px;
        }

        .product-carousel .owl-item img {
            max-width: 100%;
        }

        .item .discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }
    }
</style>